import {
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { tokens } from "../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  Add,
  CurrencyExchange,
  Delete,
  RepeatOn,
  ViewAgenda,
  WifiProtectedSetup,
} from "@mui/icons-material";
import { DollarSign } from "react-feather";

const StatBoxCustom = ({
  title,
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  getIncomeByPeriod,
  setViewIncomeCustom,
  viewIncomeCustom,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Paper
      variant="elevation"
      elevation={4}
      display="flex"
      sx={{
        width: "100%",
        height: "100%",
        justifyItems: "center",
        alignContent: "center",
        alignItems: "center",
        padding: "25px",
      }}
    >
      <Box width="100%" m="0 30px">
        <Box
          sx={{
            m: "-30px -10px",
            position: "absolute",
          }}
        >
          <IconButton
            aria-label="delete"
            onClick={() => setViewIncomeCustom(viewIncomeCustom ? false : true)}
          >
            <WifiProtectedSetup color="success" />
          </IconButton>
        </Box>
        <Box display="flex" justifyContent="center" mt="8px">
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label="Date From"
                  format="YYYY-MM-DD"
                  sx={{ width: "100%" }}
                  value={dateFrom}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                    },
                  }}
                  onChange={(newVal) => setDateFrom(newVal)}
                />
              </DemoContainer>
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  label="Date To"
                  format="YYYY-MM-DD"
                  sx={{ width: "100%" }}
                  value={dateTo}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                    },
                  }}
                  onChange={(newVal) => setDateTo(newVal)}
                />
              </DemoContainer>
            </LocalizationProvider>
            <Box width="100%" display="flex" justifyContent="center" mt="10px">
              <Button
                type="button"
                startIcon={<CurrencyExchange />}
                color="secondary"
                variant="contained"
                size="small"
                onClick={() => getIncomeByPeriod(dateFrom, dateTo)}
              >
                SHOW DATA
              </Button>
            </Box>
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" mt="2px">
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ color: colors.grey[600] }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default StatBoxCustom;
